<template>
  <div class="expert">
    <TitleBlock :text="title" :size="'two-string'" />
    <ExpertCard :name="name" :email="email" :photo="photo" />
  </div>
</template>

<script>
export default {
  name: "Expert",
  components: {
    TitleBlock: () => import("../../components/elements/TitleBlock"),
    ExpertCard: () => import("../../components/elements/ExpertCard"),
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    email: {
      type: String,
      default: null,
    },
    photo: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.expert {
  background: rgba(214, 207, 141, 0.1);
  padding-bottom: 2.4rem;
  border-bottom: 1px solid $border;
  margin-bottom: 2.8rem;

  &-card {
    padding-left: 1.6rem;
    margin-top: 1.6rem;
  }
}
</style>
